import { FieldError } from "react-hook-form";

export const getErrorMessage: (error: FieldError) => undefined | string = (
  error
) => {
  if (!error?.message) return undefined;
  return error.message;
};
